define(["require", "exports", "jquery", "./querystring", "./dialogs/login"], function (require, exports, $, querystring_1, login_1) {
    "use strict";
    exports.__esModule = true;
    var Context = (function () {
        function Context() {
            this._isMobile = false;
            this.goodProductPicturesAvailable = true;
            this._isMobile = $('body').hasClass('env-phone');
        }
        Context.prototype.isMobile = function () {
            return this._isMobile;
        };
        Context.prototype.isUserLoggedIn = function () {
            return $('.header-links a.ico-logout').length > 0 || $('.header-links a.icon-head, a.header-links.icon-head').attr('href') == '/customer/info';
        };
        Context.prototype.isUserAdmin = function () {
            return $('.header-links a.ico-admin').length > 0;
        };
        Context.prototype.supportHistory = function () {
            return !!(window.history && history.pushState);
        };
        Context.prototype.htmlEncode = function (value) {
            return $('<div/>').text(value).html();
        };
        Context.prototype.htmlDecode = function (value) {
            return $('<div/>').html(value).text();
        };
        Context.prototype.getQuery = function () {
            return querystring_1.parseQuery(window.location.search);
        };
        Context.prototype.ensureUserRegistered = function (thenAction, thenActionName) {
            if (this.isUserLoggedIn()) {
                thenAction();
            }
            else {
                login_1["default"](false, thenActionName);
            }
        };
        Context.prototype.refresh = function () {
            window.location.href = window.location.href;
        };
        return Context;
    }());
    exports["default"] = new Context();
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/context.js
// module id = 5
// module chunks = 0